/* tslint:disable */
/* eslint-disable */
/**
 * PR TIMES Media List API
 * PR TIMESメディアリスト用 API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {
    AddedMediaOutletsOperationLog,
    AddedMediaOutletsOperationLogFromJSON,
    AddedMediaOutletsOperationLogFromJSONTyped,
    AddedMediaOutletsOperationLogToJSON,
} from './AddedMediaOutletsOperationLog';
import {
    DeletedMediaOutletsOperationLog,
    DeletedMediaOutletsOperationLogFromJSON,
    DeletedMediaOutletsOperationLogFromJSONTyped,
    DeletedMediaOutletsOperationLogToJSON,
} from './DeletedMediaOutletsOperationLog';
import {
    RestoredMediaListOperationLog,
    RestoredMediaListOperationLogFromJSON,
    RestoredMediaListOperationLogFromJSONTyped,
    RestoredMediaListOperationLogToJSON,
} from './RestoredMediaListOperationLog';
import {
    SavedMediaListOperationLog,
    SavedMediaListOperationLogFromJSON,
    SavedMediaListOperationLogFromJSONTyped,
    SavedMediaListOperationLogToJSON,
} from './SavedMediaListOperationLog';
import {
    UpdatedMediaListNameOperationLog,
    UpdatedMediaListNameOperationLogFromJSON,
    UpdatedMediaListNameOperationLogFromJSONTyped,
    UpdatedMediaListNameOperationLogToJSON,
} from './UpdatedMediaListNameOperationLog';
import {
    UpdatedMediaListSenderNameOperationLog,
    UpdatedMediaListSenderNameOperationLogFromJSON,
    UpdatedMediaListSenderNameOperationLogFromJSONTyped,
    UpdatedMediaListSenderNameOperationLogToJSON,
} from './UpdatedMediaListSenderNameOperationLog';

/**
 * @type PrtimesMediaListOperationLogRecordRequest
 * request of POST /prtimes_media_lists/{media_list_id}/log
 * @export
 */
export type PrtimesMediaListOperationLogRecordRequest = { actionType: 'added_media_outlets' } & AddedMediaOutletsOperationLog | { actionType: 'deleted_media_outlets' } & DeletedMediaOutletsOperationLog | { actionType: 'restored_selected_media_list_log' } & RestoredMediaListOperationLog | { actionType: 'saved_media_list' } & SavedMediaListOperationLog | { actionType: 'updated_media_list_name' } & UpdatedMediaListNameOperationLog | { actionType: 'updated_media_list_sender_name' } & UpdatedMediaListSenderNameOperationLog;

export function PrtimesMediaListOperationLogRecordRequestFromJSON(json: any): PrtimesMediaListOperationLogRecordRequest {
    return PrtimesMediaListOperationLogRecordRequestFromJSONTyped(json, false);
}

export function PrtimesMediaListOperationLogRecordRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): PrtimesMediaListOperationLogRecordRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    switch (json['actionType']) {
        case 'added_media_outlets':
            return {...AddedMediaOutletsOperationLogFromJSONTyped(json, true), actionType: 'added_media_outlets'};
        case 'deleted_media_outlets':
            return {...DeletedMediaOutletsOperationLogFromJSONTyped(json, true), actionType: 'deleted_media_outlets'};
        case 'restored_selected_media_list_log':
            return {...RestoredMediaListOperationLogFromJSONTyped(json, true), actionType: 'restored_selected_media_list_log'};
        case 'saved_media_list':
            return {...SavedMediaListOperationLogFromJSONTyped(json, true), actionType: 'saved_media_list'};
        case 'updated_media_list_name':
            return {...UpdatedMediaListNameOperationLogFromJSONTyped(json, true), actionType: 'updated_media_list_name'};
        case 'updated_media_list_sender_name':
            return {...UpdatedMediaListSenderNameOperationLogFromJSONTyped(json, true), actionType: 'updated_media_list_sender_name'};
        default:
            throw new Error(`No variant of PrtimesMediaListOperationLogRecordRequest exists with 'actionType=${json['actionType']}'`);
    }
}

export function PrtimesMediaListOperationLogRecordRequestToJSON(value?: PrtimesMediaListOperationLogRecordRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    switch (value['actionType']) {
        case 'added_media_outlets':
            return AddedMediaOutletsOperationLogToJSON(value);
        case 'deleted_media_outlets':
            return DeletedMediaOutletsOperationLogToJSON(value);
        case 'restored_selected_media_list_log':
            return RestoredMediaListOperationLogToJSON(value);
        case 'saved_media_list':
            return SavedMediaListOperationLogToJSON(value);
        case 'updated_media_list_name':
            return UpdatedMediaListNameOperationLogToJSON(value);
        case 'updated_media_list_sender_name':
            return UpdatedMediaListSenderNameOperationLogToJSON(value);
        default:
            throw new Error(`No variant of PrtimesMediaListOperationLogRecordRequest exists with 'actionType=${value['actionType']}'`);
    }
}

